export default __webpack_public_path__ + "static/media/down.38efbc5f.svg";